import React from "react";

const SvgFyzickaOsobaPodnikatel = props => (
  <svg viewBox="0 0 210 208" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Obecn\xE9 ikony">
        <g data-name="Fyzicka osoba podnikatel">
          <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h210v208H0z" />
          <path d="M77.13 7.16a39.54 39.54 0 1039.52 39.52A39.5 39.5 0 0077.13 7.16zm-28 78.31c-23.78 6.22-40.5 22.33-40.5 57.05 0 28.29 48.93 39.52 88.3 34v-32.89a14 14 0 0114-14.07h15.56a9 9 0 011.63.32v-1.59a14.82 14.82 0 0112.06-14.58c-6.72-15.44-19.25-24.1-35-28.24a47.81 47.81 0 01-22.88 8.76L79 99.92l7.62 50.83-9.52 17.05-9.5-17.05 7.59-50.86-3.27-5.69a47.71 47.71 0 01-22.77-8.73z" />
          <path d="M142.91 123.63a4.68 4.68 0 00-4.67 4.67v6.78a2.34 2.34 0 104.67 0v-6.78h21.77v6.78a2.34 2.34 0 104.67 0v-6.78a4.68 4.68 0 00-4.67-4.67zm-32 16.1a3.83 3.83 0 00-3.79 3.89v54.43a3.83 3.83 0 003.79 3.89h15.54v-62.21zm23.32 0v62.21h39.06v-62.21zm46.84 0v62.21h15.59a3.85 3.85 0 003.81-3.89v-54.43a3.85 3.85 0 00-3.81-3.89z" />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgFyzickaOsobaPodnikatel;
